import { render, staticRenderFns } from "./EventFlowSwitch.vue?vue&type=template&id=d787b670&scoped=true"
import script from "./EventFlowSwitch.vue?vue&type=script&lang=ts"
export * from "./EventFlowSwitch.vue?vue&type=script&lang=ts"
import style0 from "./EventFlowSwitch.vue?vue&type=style&index=0&id=d787b670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d787b670",
  null
  
)

export default component.exports